import React from 'react';

export default function Pagination({ links, onSearch }) {
    if (!links || links.length === 0) return null;

    return (
        <div className="flex justify-center">
            <nav className="inline-flex -space-x-px rounded-md shadow-sm" aria-label="Paginação">
                {links.map((link, index) => {
                    const isFirst = index === 0;
                    const isLast = index === links.length - 1;

                    let btnClasses = "relative inline-flex items-center px-2.5 py-1 text-sm font-medium focus:z-20 transition-colors duration-150 ";

                    if (isFirst) btnClasses += "rounded-l-md ";
                    if (isLast) btnClasses += "rounded-r-md ";

                    if (link.active) {
                        btnClasses += "z-10 text-white bg-[#063A6C] hover:bg-blue-800 focus:ring-blue-300 disabled:hover:bg-blue-700 ";
                    } else if (!link.url && !link.page) {
                        btnClasses += "bg-gray-100 text-gray-400 border border-[#e7eaec] ";
                    } else {
                        btnClasses += "text-gray-700 bg-white hover:bg-gray-200 focus:ring-0 border border-[#e7eaec] disabled:hover::bg-white cursor-pointer ";
                    }

                    return (
                        <button
                            key={index}
                            disabled={!link.page && !link.url}
                            onClick={() => {
                                if (link.page && !link.active) {
                                    onSearch(link.page);
                                }
                            }}
                            className={btnClasses}
                        >
                            {link.label}
                        </button>
                    );
                })}
            </nav>
        </div>
    );
}